export default __webpack_public_path__ + "static/media/pilares.26303cdb.png";